import React from 'react';
import { Tabs } from 'src/common/form/tabs';
import OrganizationLink from 'src/common/OrganizationLink';
import { functionNoop } from 'src/utils/function/noop';
import { DashboardInsightsJourneysTabType } from '../constants';

type Props = {
  journeyUuid: string;
  sessionUuid: string;
  activeTab: DashboardInsightsJourneysTabType;
};

export const DashboardInsightsJourneysJourneyVisitorTabs = ({ journeyUuid, sessionUuid, activeTab }: Props) => {
  return (
    <Tabs
      theme='bedrock'
      value={activeTab}
      onChange={functionNoop}
      options={[
        {
          value: 'steps',
          label: (
            <OrganizationLink to={`/insights/journeys/${journeyUuid}/${sessionUuid}/steps`} className='flex'>
              Steps within Journey
            </OrganizationLink>
          ),
        },
        {
          value: 'visitor-sessions',
          label: (
            <OrganizationLink to={`/insights/journeys/${journeyUuid}/${sessionUuid}/visitor-sessions`} className='flex'>
              Visitor sessions
            </OrganizationLink>
          ),
        },
      ]}
    />
  );
};
